import React from "react";
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { Landing } from 'components'

const HomePage = () => {

  return (
    <HomeContainer>
      <Landing />
    </HomeContainer>
  );
};

const HomeContainer = styled(Container)`
  margin-top: -1rem;
`;

export default HomePage;
